import { useDispatch, useReduxState } from 'hooks';
import api from 'api';
import { ModalButtonWithForm } from 'components/common';
import { AchievementTemplateItemForm } from '.';

interface Props {
  achievementId: number;
  item: { id: number; text: string; order: number };
  itemAnswerableByUserLabel: string;
  itemLabel: string;
  itemMarkableByUserLabel: string;
  modalTitle: string;
  numberOfItems: number;
  successMessage: string;
  updateTemplate: () => Promise<void>;
}

const AchievementTemplateUpdateItem = ({
  achievementId,
  item,
  itemAnswerableByUserLabel,
  itemLabel,
  itemMarkableByUserLabel,
  modalTitle,
  numberOfItems,
  successMessage,
  updateTemplate
}: Props) => {
  const { dispatch } = useDispatch();

  const {
    messages,
    pageState: { achievement }
  } = useReduxState();

  const handleSubmit = async (values: typeof item) => {
    try {
      const response = await api.put(
        `/admin/achievements/${achievementId}/template/${item.id}`,
        { ...values, id: item.id }
      );
      await updateTemplate();

      if (response.data?.isIncompleteToggled) {
        dispatch.updatePageState({
          achievement: { ...achievement, isIncompleteViewableByUser: true }
        });
      }
      dispatch.addNotice({ text: successMessage, type: 'success' });
    } catch (err) {
      await dispatch.handleErrorDispatch(err);
    }
  };

  return (
    <ModalButtonWithForm
      buttonCategory="success"
      buttonIcon="pen"
      buttonIsDropdown={true}
      buttonText={messages.commonEdit}
      initialValues={{ ...item }}
      modalActionText={messages.commonSave}
      modalTitle={modalTitle}
      modalWidth="medium"
      onSubmit={handleSubmit}
      pristineIsValid={false}
    >
      {() => (
        <AchievementTemplateItemForm
          itemId={item.id}
          itemAnswerableByUserLabel={itemAnswerableByUserLabel}
          itemLabel={itemLabel}
          itemMarkableByUserLabel={itemMarkableByUserLabel}
          numberOfItems={numberOfItems}
        />
      )}
    </ModalButtonWithForm>
  );
};

export default AchievementTemplateUpdateItem;
